import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returnera event-titel med ämnesprefix om det finns.
 * Exempel:
 *   { subject: "Engelska", summary: "The BFG prov" } → "Engelska - The BFG prov"
 *   { summary: "Träning" } → "Träning"
 */
export function formatEventTitle(event, fallback = "") {
  if (!event) return fallback;
  const summary = (event.summary || "").trim();
  const subject = (event.subject || "").trim();
  if (!summary) return subject || fallback;
  if (!subject) return summary;
  // Undvik dubbel-prefix om summary redan inleds med ämnesnamnet
  if (summary.toLowerCase().startsWith(subject.toLowerCase())) return summary;
  return `${subject} - ${summary}`;
}

/** True om ett event verkar vara inställt (träning/match etc). */
export function isCancelledEvent(event) {
  if (event?.cancelled === true) return true;
  const s = `${event?.summary || ""} ${event?.description || ""}`;
  return /inställd|inställt|cancelled/i.test(s);
}
